import APICall from "../APICall";

const getStats = async (payload) => {
  const res = await APICall("user/getStats", "POST", payload);
  return res;
};

// const validateUserBVN = async (payload) => {
//   const res = await APICall("user/validate_bvn", "POST", payload);
//   return res;
// };

const getUserDetails = async () => {
  const { data } = await APICall("user/get_user_details", "GET");
  return { data };
};

const getMyStats = async () => {
  const { data } = await APICall("user/mystats", "GET");
  return { data };
};

const updatePassword = async (payload) => {
  const res = await APICall("update-password", "POST", payload, true);
  return res;
};

const hashUser = async () => {
  const res = await APICall("/user/hash-user", "POST");
  return res;
};

const getNotifications = async () => {
  const res = await APICall("/notifications/list?page=1&pageLimit=50", "GET");
  return res;
};
const markNotificationAsRead = async (notificationId) => {
  const res = await APICall(`/notifications/read/${notificationId}`, "PATCH");
  return res;
};

const activateLoanMandateAuthorization = async (payload) => {
  const response = await APICall(
    "loan_repayment/validate-card-mandate",
    "POST",
    payload
  );
  return response;
};

const userServices = {
  getStats,
  getUserDetails,
  getMyStats,
  updatePassword,
  hashUser,
  getNotifications,
  markNotificationAsRead,
  activateLoanMandateAuthorization,
};

export default userServices;
